import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import "./settings.css"
import { refreshUser, updateUser } from "../../appState/slices/auth/authSlice";
import { setToastMessage } from "../../appState/slices/util/utilSlice";

const Settings = () => {
    const user = useSelector(state => state.auth.user);
    // const [detailsChanged, setdetailsChanged] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        control,
        formState: { errors },
    } = useForm();
    const date = new Date(user.dob);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based, so add 1
    const day = date.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    const dispatch = useDispatch();
    const onSubmit = async(data) => {
        let detailsChanged = false;
        let userdetails = {};
        if (user.name !== data.name) {
            userdetails.name = data.name;
            // setdetailsChanged(true);
            detailsChanged = true;
        }
        else if (user.email !== data.email) {
            userdetails.email = data.email;
            detailsChanged = true;
            // setdetailsChanged(true);
        }
        else if (user.gender !== data.gender) {
            userdetails.gender = data.gender;
            detailsChanged = true;
            // setdetailsChanged(true);
        }
        else if (user.phoneNumber !== data.phone) {
            userdetails.phoneNumber = data.phone;
            detailsChanged = true;
            // setdetailsChanged(true);
        }
        else if (formattedDate !== data.dob) {
            userdetails.dob = data.dob;
            detailsChanged = true;
            // setdetailsChanged(true);
        }

        if (detailsChanged === true) {
            try {
                await dispatch(updateUser(userdetails));
                await dispatch(refreshUser());
                await dispatch(setToastMessage({
                    type: "success",
                    message: "User Updated Successfully",
                    show: true,
                }))
            } catch (error) {
                await dispatch(setToastMessage({
                    type: "error",
                    message: "Something went wrong",
                    show: true,
                }))
            }
        }

    };

    return (
        <div>
            <hr className="myorders-line"></hr>
            <div className="single-order-fixed">
                <div className="myordercontainer">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="profile-details-container t5">
                            <div className="t3 font-semibold">
                                my profile
                            </div>
                            <Controller
                                name="name"
                                control={control}
                                defaultValue={user ? user.name : ""}
                                render={({ field }) => (
                                    <div className="delivery-input-container" >
                                        <input type="name" placeholder="name" {...field} />
                                    </div>
                                )}
                            />
                            <Controller
                                name="email"
                                control={control}
                                defaultValue={user ? user.email : ""}
                                render={({ field }) => (
                                    <div className="delivery-input-container" >
                                        <input type="email" placeholder="email" {...field} />
                                    </div>
                                )}
                            />
                            <Controller
                                name="phone"
                                control={control}
                                defaultValue={user ? user.phoneNumber : ""}
                                render={({ field }) => (
                                    <div className="delivery-input-container" >
                                        <input type="phone" placeholder="phone" {...field} />
                                    </div>
                                )}
                            />
                            <Controller
                                name="dob"
                                control={control}
                                defaultValue={user ? formattedDate : ""}
                                render={({ field }) => (
                                    <div className="delivery-input-container" >
                                        <input type="date" placeholder="dob" {...field} />
                                    </div>
                                )}
                            />
                            <Controller
                                name="gender"
                                control={control}
                                defaultValue={user ? user.gender : ""}
                                render={({ field }) => (
                                    <div className="delivery-input-container" >
                                        <select className="form-dropdown" {...field}>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                        </select>
                                    </div>
                                )}
                            />
                            <button className="profile-update-btn font-semibold t5" type="submit">
                                Update
                            </button>
                        </div>

                    </form>
                </div>
            </div>

        </div>
    )
}

export default Settings;